<script setup lang="ts">
  useHead({
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: '/images/lo-hp-new/hero-andy-lg@1x.webp',
        imagesrcset: '/images/lo-hp-new/hero-andy-lg@1x.webp 1x, /images/lo-hp-new/hero-andy-lg@2x.webp 2x',
        imagesizes: '50vw',
        media: '(min-width: 1280px)',
        fetchpriority: 'high',
      },
    ],
  });
</script>

<template>
  <LoggedOutNewHeroBackgroundGradient />

  <div class="max-w-[60%] absolute inset-0 flex flex-col items-start justify-start py-10 pr-0 pl-[4.6875rem]">
    <NuxtImg
      class="max-w-[18.75rem] mx-0 mb-auto"
      src="/images/lo-hp-new/hero-logo-desktop.webp"
      format="webp"
      densities="x1 x2"
      alt="MAXDUEL LOGOTYPE"
      preload
    />

    <div class="mt-0 mx-0 mb-auto text-left text-white">
      <p class="text-[2.375rem] tracking-[0.76px] not-italic font-extrabold leading-none">PLAY ORIGINAL PvP GAMES</p>
      <p class="flex items-center gap-2 font-extrabold leading-none text-[2.6875rem] tracking-[0.86px]">
        TO
        <b class="italic text-[3.8125rem] tracking-[1.22px] font-black text-[#5bb5fa]">WIN REAL CASH</b>
      </p>
    </div>

    <CoreButton color="green" class="w-[14.25rem] h-[3.25rem] px-8 py-4 justify-center items-center mx-0">
      <span class="font-inter text-lg font-extrabold leading-none tracking-[0.16px] uppercase">PLAY NOW</span>
    </CoreButton>
  </div>

  <div class="absolute z-1 top-0 right-0 desktop-1660:right-[10%] grid grid-areas-['stack'] place-items-end">
    <img
      alt="FACE FORMER HEAVYWEIGHT CHAMPION ANDY RUIZ JR. AND WIN BIG!"
      class="[grid-area:stack]"
      srcset="/images/lo-hp-new/hero-andy-lg@1x.webp 1x, /images/lo-hp-new/hero-andy-lg@2x.webp 2x"
      src="/images/lo-hp-new/hero-andy-lg@1x.webp"
      fetchpriority="high"
      sizes="100vw"
    />
    <div
      class="text-shadow-banner text-white text-center font-barlow text-[1.1875rem] not-italic font-extrabold leading-[120%] [grid-area:stack] translate-x-[-100px] translate-y-[-20%]"
    >
      FACE FORMER HEAVYWEIGHT CHAMPION
      <br />
      <i class="text-[#5BB5FA] text-[1.3125rem] italic font-black">ANDY RUIZ JR.</i>
      AND WIN BIG!
    </div>
  </div>
</template>
